import { helper } from '@ember/component/helper';

export const addNumber = (params) =>
  Number.parseInt(params[0], 10) + Number.parseInt(params[1], 10);

export default helper(addNumber);
